import { render, staticRenderFns } from "./AssetAssociationsContainer.vue?vue&type=template&id=b2d0fd04&scoped=true&"
import script from "./AssetAssociationsContainer.vue?vue&type=script&lang=js&"
export * from "./AssetAssociationsContainer.vue?vue&type=script&lang=js&"
import style0 from "./AssetAssociationsContainer.vue?vue&type=style&index=0&id=b2d0fd04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d0fd04",
  null
  
)

export default component.exports